import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgMenuIcon(props) {
  return jsx("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.02 1H0v1.25h16.02V1Zm0 6.74H0v1.25h16.02V7.74ZM0 14.48h8.72v1.25H0v-1.25Z",
    fill: "currentColor"
  }));
}

export { SvgMenuIcon as default };
